export interface MetalPuritySource {
    denumire: string;
    karat: number;
    percent?: number;
}

const commonGoldPurities: Record<number, number> = {
    14: 585,
    18: 750,
    24: 999,
};

export function normalizeMetalObjectPurity<T extends MetalPuritySource>(metalObject: T): T {
    const purityFromPercent = Number(metalObject.percent);
    if (Number.isFinite(purityFromPercent) && purityFromPercent > 0) {
        return { ...metalObject, karat: purityFromPercent };
    }

    if (metalObject.karat > 100) {
        return metalObject;
    }

    const purityFromName = /\b(?:AUR|AU|ARGINT|AG)\s*(\d{3})\b/i.exec(metalObject.denumire);
    if (purityFromName) {
        return { ...metalObject, karat: Number(purityFromName[1]) };
    }

    const mappedPurity = commonGoldPurities[metalObject.karat];
    if (mappedPurity) {
        return { ...metalObject, karat: mappedPurity };
    }

    return metalObject;
}
